import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b50891ba&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b50891ba')) {
      api.createRecord('b50891ba', component.options)
    } else {
      api.reload('b50891ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b50891ba&", function () {
      api.rerender('b50891ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/index.vue"
export default component.exports